<template>

</template>

<script>
  export default {
    name: 'app-layout-footer',

    methods: {
      getLayoutFooterBg () {
        return `bg-${this.layoutFooterBg}`
      }
    }
  }
</script>
